var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard8Clubs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 309.4 427.3",
    style: {
      enableBackground: "new 0 0 309.4 427.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6EEF4;}\n\t.st1{clip-path:url(#SVGID_00000040546366460519476070000013634809381000039830_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.7,0h-280C6.6,0,0,6.6,0,14.7v397.9c0,8.1,6.6,14.7,14.7,14.7h280c8.1,0,14.7-6.6,14.7-14.7V14.7 C309.5,6.6,302.9,0,294.7,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.5,292.5c0,17.8,4.9,35.7,6.6,41.3c0.3,0.9-0.4,1.8-1.4,1.8h-53.6c-1,0-1.7-0.9-1.4-1.8c1.7-5.7,6.6-23.7,6.6-41.3 c-7.1,5.1-15.3,7.8-24.4,7.8c-26.3,0-49.1-22.1-47.4-48.7c0.9-15,10.4-27.8,23.1-35.8s24.6-8.6,35.1-6.1 c-6.8-8-10.8-18.3-10.8-29.6c0-28.4,25.7-50.7,55.1-45c18.4,3.6,33,18.7,36.1,37.1c2.4,14.3-1.9,27.7-10.2,37.5 c10.6-2.6,22.5-1.9,35.4,6.2c12.6,8,22.1,20.8,23,35.8c1.5,26.5-21.3,48.5-47.5,48.5C187.9,300.3,179.4,297.6,172.5,292.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3,32c-15.9,0-28.7,12.9-28.7,28.7c0,15.9,12.9,28.7,28.7,28.7S79,76.5,79,60.7C79,44.8,66.2,32,50.3,32z M50.3,75.1 c-7.9,0-14.4-6.4-14.4-14.4s6.4-14.4,14.4-14.4s14.4,6.4,14.4,14.4S58.2,75.1,50.3,75.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3,75.1c-15.9,0-28.7,12.9-28.7,28.7c0,15.9,12.9,28.7,28.7,28.7S79,119.6,79,103.8C79,87.9,66.2,75.1,50.3,75.1z  M50.3,118.2c-7.9,0-14.4-6.4-14.4-14.4s6.4-14.4,14.4-14.4s14.4,6.4,14.4,14.4S58.2,118.2,50.3,118.2z"
  })), /*#__PURE__*/React.createElement("g", null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M281.9,370.5c0,20.3-16.5,36.8-36.8,36.8s-36.8-16.5-36.8-36.8c0-20.3,16.5-36.8,36.8-36.8S281.9,350.1,281.9,370.5z  M245.1,340c-16.8,0-30.4,13.6-30.4,30.4s13.6,30.4,30.4,30.4s30.4-13.6,30.4-30.4S261.9,340,245.1,340z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M269.8,363.7c0,6.5-5.7,12.4-12.8,12.4c-7.2-0.3-12.8-5.9-12.8-12.4c0-6.5,5.7-12.2,12.8-12.4 C264.1,351.5,269.8,357.1,269.8,363.7z M264.7,363.7c0-4.2-3.5-7.6-7.8-7.6c-4.3,0-7.8,3.4-7.8,7.6s3.5,7.6,7.8,7.6 C261.2,371.2,264.7,367.9,264.7,363.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M254.1,386.7c0,3.5-3,6.3-6.9,6.5c-3.8,0-6.9-3-6.9-6.5c0-3.5,3.1-6.5,6.9-6.5C251,380.4,254.1,383.2,254.1,386.7z  M249.9,386.7c0-1.4-1.2-2.6-2.6-2.6c-1.5,0-2.6,1.1-2.6,2.6s1.2,2.6,2.6,2.6C248.7,389.3,249.9,388.2,249.9,386.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M237.2,359.9c-1.6,0-3,1.3-3,2.8c0,1.5,1.3,2.8,3,2.8c1.7,0,3-1.2,3-2.8C240.2,361.1,238.8,359.9,237.2,359.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M227.3,379.8c-1.6,0-3,1.3-3,2.8s1.3,2.8,3,2.8c1.7,0,3-1.2,3-2.8S228.9,379.8,227.3,379.8z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M263.1,383.5c-1.6,0-3,1.3-3,2.8c0,1.5,1.3,2.8,3,2.8c1.7,0,3-1.2,3-2.8C266,384.8,264.7,383.5,263.1,383.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 245.1,
    cy: 370.5,
    r: 30.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132070937598742829700000005889755550343966596_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000132070937598742829700000005889755550343966596_)"
    },
    d: "M234.5,350.7 c-0.2,3.5-3.4,6.2-7.2,6c-3.8-0.2-6.7-3.4-6.4-6.9c0.2-3.5,3.4-6.3,7.2-6.1C231.8,344.2,234.7,347.3,234.5,350.7z M230.2,350.5 c0.1-1.4-1-2.6-2.5-2.7c-1.5-0.1-2.7,1-2.8,2.4c-0.1,1.4,1,2.6,2.5,2.7C228.9,353,230.2,351.9,230.2,350.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard8Clubs);
export default __webpack_public_path__ + "static/media/card_8-clubs.724645a60592a981c9d1615ab22289c5.svg";
export { ForwardRef as ReactComponent };